import React from 'react';

import styles from './ActionsBar.module.scss';

interface ActionButton {
  src: string;
  alt: string;
  onClick: () => void;
  placement: 'left' | 'center' | 'right';
}

interface ActionsBarProps {
  actionButtons: Array<ActionButton>;
}

const ActionsBar = ({ actionButtons }: ActionsBarProps) => {
  const leftIcons: JSX.Element[] = [];
  const rightIcons: JSX.Element[] = [];
  const centerIcons: JSX.Element[] = [];

  actionButtons.forEach(({ src, alt, placement, onClick }) => {
    const btn = (
      <button
        key={alt}
        className={styles.actions_bar__icon_container}
        onClick={onClick}
        type="button"
        title={alt}
      >
        <img src={src} alt={alt} />
      </button>
    );

    if (placement === 'left') leftIcons.push(btn);
    if (placement === 'right') rightIcons.push(btn);
    if (placement === 'center') centerIcons.push(btn);
  });

  return (
    <div className={styles.actions_bar}>
      <div className="d-flex justify-content-start">{leftIcons}</div>
      <div className="d-flex justify-content-center">{centerIcons}</div>
      <div className="d-flex justify-content-end">{rightIcons}</div>
    </div>
  );
};

export default ActionsBar;
